<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">Filtri</span>
  <button mat-icon-button type="button" aria-label="Chiudi" class="close-button" (click)="onClose()">
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content" [formGroup]="filterForm">
  <mat-form-field appearance="outline">
    <mat-label>Tipo Zona</mat-label>
    <input matInput formControlName="tipoZona" [matAutocomplete]="autoTipoZona" placeholder="Tutti">
    <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
    <mat-autocomplete #autoTipoZona="matAutocomplete">
      @for (option of filteredTipoZona | async; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Zona</mat-label>
    <input matInput formControlName="zona" [matAutocomplete]="autoZona" placeholder="Zona">
    <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
    <mat-autocomplete #autoZona="matAutocomplete" (optionSelected)="onZonaSelected($event.option.value)">
      @for (option of filteredZona | async; track option.id) {
        <mat-option [value]="option">{{ option.nome }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (dialogData.options.agente.length) {
    <mat-form-field appearance="outline">
      <mat-label>Agente</mat-label>
      <input matInput formControlName="agente" [matAutocomplete]="autoAgente" placeholder="Tutti">
      <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
      <mat-autocomplete #autoAgente="matAutocomplete" (optionSelected)="onAgenteSelected($event.option.value)">
        @for (option of filteredAgente | async; track option.value) {
          <mat-option [value]="option">{{ option.label }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }

  @if (dialogData.options.ispettore.length) {
    <mat-form-field appearance="outline">
      <mat-label>Ispettore</mat-label>
      <input matInput formControlName="ispettore" [matAutocomplete]="autoIspettore" placeholder="Tutti">
      <i matSuffix class="fa-regular fa-chevron-down icon-suffix"></i>
      <mat-autocomplete #autoIspettore="matAutocomplete" (optionSelected)="onIspettoreSelected($event.option.value)">
        @for (option of filteredIspettore | async; track option.value) {
          <mat-option [value]="option">{{ option.label }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }

  <mat-form-field appearance="outline">
    <mat-label>Data ultima fattura</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="dataUltimaFattura" placeholder="GG/MM/AAAA">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-checkbox formControlName="newCustomer">Cliente nuovo</mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions class="buttons-container">
  <button matButton type="button" (click)="onReset()">Cancella</button>
  <button matButton="filled" type="button" (click)="onApply()">Applica</button>
</mat-dialog-actions>
